/**
 *  blade-cart-sheet.js — Phase 2 of CART-BRIEF.md
 *
 *  Swipe-down-to-dismiss for the mobile bottom sheet. The brief is explicit:
 *  the drag handle only earns its place if the gesture actually works.
 *
 *  Closing routes through the theme's own .side-panel-close element rather
 *  than reaching into OverlayManager, so the existing close path — focus
 *  restore, body scroll unlock in cart-drawer-fix.js — runs unchanged.
 *
 *  Escape and backdrop-tap are already handled by the theme.
 */
(function () {
  var MOBILE = 749;

  function init() {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer || drawer.dataset.bladeSheet === 'true') return;
    drawer.dataset.bladeSheet = 'true';

    var header = drawer.querySelector('.side-panel-header');
    if (!header) return;

    var startY = 0;
    var startT = 0;
    var dy = 0;
    var active = false;
    var captured = false;
    var ptr = null;

    function isMobile() {
      return window.matchMedia('(max-width: ' + MOBILE + 'px)').matches;
    }

    header.addEventListener('pointerdown', function (e) {
      if (!isMobile()) return;
      /* Never swallow a tap meant for a control — the close X lives in here. */
      if (e.target.closest('button, a, input, textarea, select, side-panel-close')) return;
      active = true;
      captured = false;
      ptr = e.pointerId;
      startY = e.clientY;
      startT = Date.now();
      dy = 0;
    });

    header.addEventListener('pointermove', function (e) {
      if (!active) return;
      dy = Math.max(0, e.clientY - startY);
      /* Capture only once it is genuinely a drag, so a plain tap stays a tap. */
      if (!captured && dy > 4) {
        captured = true;
        drawer.classList.add('is-dragging');
        try { header.setPointerCapture(ptr); } catch (err) {}
      }
      if (captured) drawer.style.transform = 'translateY(' + dy + 'px)';
    });

    function end() {
      if (!active) return;
      active = false;
      if (captured) { try { header.releasePointerCapture(ptr); } catch (err) {} }
      captured = false;
      drawer.classList.remove('is-dragging');
      drawer.style.transform = '';

      var fast = dy / Math.max(1, Date.now() - startT) > 0.5; /* flick */
      if (dy > drawer.offsetHeight * 0.25 || (fast && dy > 40)) {
        var closer = drawer.querySelector('side-panel-close, .side-panel-close');
        if (closer) closer.click();
      }
    }

    header.addEventListener('pointerup', end);
    header.addEventListener('pointercancel', end);
  }

  /* Express wallets: no JS any more (10 Oct). They render as one horizontal
     row under the checkout button, laid out by Shopify's own component once
     the wrapper dropped the --vertical class — see cart-drawer.liquid. The old
     .is-split logic (wallet beside checkout when exactly one rendered) is gone. */

  /* Move the gift app's progress card out of the pinned footer and into
     .blade-gift-slot at the end of the basket, above "You may also like".

     Relocating the node does NOT break it — verified 9 Sep on the live drawer:
     after the move the card kept updating itself, going from "Spend £34.00
     more to unlock" to "Spend £12.00 more" when an item was added. The app
     holds a reference to the element, not to its position.

     Two things this has to survive:
       1. The app nests a SECOND element of the same class inside the first, at
          zero height. Always take the outermost, or the card gets torn in half.
       2. Our drawer re-renders wholesale on every cart change (cart.js swaps
          .side-panel-inner), after which the app re-injects into its own
          anchor. So this runs again on each render and on DOM mutations. */
  function outermostGiftCard(root) {
    var cards = root.querySelectorAll('.gfgUnifiedDiscountWrapper');
    for (var i = 0; i < cards.length; i++) {
      if (!cards[i].parentElement.closest('.gfgUnifiedDiscountWrapper')) return cards[i];
    }
    return null;
  }

  function placeGiftWidget() {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;
    var slot = drawer.querySelector('.blade-gift-slot');
    if (!slot) return;
    var card = outermostGiftCard(drawer);
    /* Already in place — returning here is also what stops the MutationObserver
       below from re-triggering itself into a loop. */
    if (!card || card.parentElement === slot) return;
    slot.appendChild(card);
  }

  /* Watch the <cart-drawer> element itself, NOT .side-panel-inner.

     Measured 9 Sep with probe attributes on both nodes across a real cart
     change: #Cart-Drawer survived (it carries the open state and the theme's
     OverlayManager reference) but .side-panel-inner was REPLACED, not just
     re-filled. An observer on the inner therefore died on the first re-render
     and the card stayed behind in the footer — which is exactly what happened
     on the first pass here. The drawer element persists for the life of the
     page, so one observer on it covers every cart path, including the ones
     that never dispatch blade:cart:updated. */
  function watchGiftWidget() {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer || drawer.dataset.bladeGiftWatch === 'true') return;
    drawer.dataset.bladeGiftWatch = 'true';
    new MutationObserver(placeGiftWidget).observe(drawer, { childList: true, subtree: true });
  }

  function boot() { init(); placeGiftWidget(); watchGiftWidget(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('blade:cart:updated', boot);
})();
